const TAG_NAME = "tqc-closeable-container";
class CloseableContainer extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("button[data-container-closer]").forEach((button) => {
      button.addEventListener("click", () => {
        const closeableContainer = button.closest(TAG_NAME);
        if (closeableContainer) {
          closeableContainer.remove();
        } else {
          console.warn(
            "container closer can't find enclosing closable container",
          );
        }
      });
    });
  }
}
window.customElements.define(TAG_NAME, CloseableContainer);
